import { createTextComponent } from './createTextComponent';

export const HeadingSmall = createTextComponent({
  styleAs: 'headingSmall',
  tag: 'h5',
});
